import { useStore } from "vuex"
import GetLabel from "foundation/js/getLabel"

export default {
    name: "DeleteCommentOverlay",
    setup(){
        const store = useStore()

        const deleteComment = () => {
            store.state.main.page_overlay_content_data.callback()
        }

        return {
            getLabel: (labelKey) => GetLabel({ labelKey, labelCollection: 'DeleteCommentOverlay' }),
            deleteComment
        }
    }
}